module.exports = __webpack_public_path__ + "static/media/nestje7.39c08303.jpg";